<template>
  <div class="select-style">
    <a
      class="select-btn"
      :class="{
        isopen: selectIsOpen,
        soldout: selected.Product && selected.Stock === 0,
      }"
      @click.prevent.stop="openSelector"
    >
      {{ selected.Name }} {{ selected.Product.PreOrder ? '(Pre-order)' : '' }}
    </a>
    <ul class="select-opts" :class="{ isopen: selectIsOpen }">
      <li
        v-for="opt in options"
        :key="opt.Name"
        :data-value="opt.Name"
        :class="{ soldout: opt.Stock === 0 }"
        @click.prevent="changeSelect(opt)"
      >
        {{ opt.Name }} <span v-if="opt.Product.PreOrder">(Pre-order)</span>
      </li>
    </ul>
  </div>
</template>

<script setup>
import $ from 'jquery';
import { ref, onMounted } from 'vue';

const selectIsOpen = ref(false);

const props = defineProps({
  options: {
    type: Object,
    default: () => ({}),
  },
  selected: {
    type: Object,
    default: () => ({}),
  },
});

function openSelector() {
  selectIsOpen.value = !selectIsOpen.value;
}

const emit = defineEmits(['changeFoodSpec']);

function changeSelect(opt) {
  selectIsOpen.value = false;
  emit('changeFoodSpec', opt);
}

onMounted(() => {
  $(window).click(() => {
    selectIsOpen.value = false;
  });
});
</script>
